module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipeleft",
      value: (_vm.test),
      expression: "test",
      arg: "swipeleft"
    }, {
      name: "touch",
      rawName: "v-touch:swiperight",
      value: (_vm.test),
      expression: "test",
      arg: "swiperight"
    }, {
      name: "touch",
      rawName: "v-touch:swipeup",
      value: (_vm.test),
      expression: "test",
      arg: "swipeup"
    }, {
      name: "touch",
      rawName: "v-touch:swipedown",
      value: (_vm.test),
      expression: "test",
      arg: "swipedown"
    }, {
      name: "touch",
      rawName: "v-touch:tap",
      value: (_vm.test),
      expression: "test",
      arg: "tap"
    }, {
      name: "touch",
      rawName: "v-touch:press",
      value: (_vm.test),
      expression: "test",
      arg: "press"
    }, {
      name: "touch",
      rawName: "v-touch:pinchin",
      value: (_vm.test),
      expression: "test",
      arg: "pinchin"
    }, {
      name: "touch",
      rawName: "v-touch:pinchout",
      value: (_vm.test),
      expression: "test",
      arg: "pinchout"
    }],
    staticClass: "text-center margin-top-large",
    staticStyle: {
      "min-height": "400px",
      "background": "#E5E5E5"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "3em"
    }
  }, [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7c3757c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/testtouch.vue
// module id = 189
// module chunks = 2